import axios from "axios";
import store from "../store";
const { ConcurrencyManager } = require("axios-concurrency");

export const HTTP_TOKEN = axios.create({
  baseURL:
    process.env.VUE_APP_API_ENDPOINT || "http://localhost:8000/api/panel/v1/",
  headers: {
    Authorization: "Bearer {token}",
    "Content-Type": "application/json;charset=UTF-8",
  },
});

export const HTTP = axios.create({
  baseURL:
    process.env.VUE_APP_API_ENDPOINT || "http://localhost:8000/api/panel/v1/",
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

export const HTTP_TOKEN_REPORT = axios.create({
  baseURL:
    process.env.VUE_APP_REPORT_ENDPOINT ||
    "http://localhost:8000/api/report/v1/",
  headers: {
    Authorization: "Bearer {token}",
    "Content-Type": "application/json;charset=UTF-8",
  },
});

var cache_request = {};

export const CLEAN_ALL_CACHE = () => {
  cache_request = {};
};

export const getAccountParamOrLocal = () => {
  let account = localStorage.getItem("account");

  let url = window.location.toString();
  if (url && url.includes("#")) {
    let auxParam = url.split("#")[1];

    // fail split
    if (!auxParam) {
      return account;
    }

    auxParam = auxParam.split("acc=");

    // fail split
    if (auxParam && auxParam.length < 2) {
      return account;
    }

    account = auxParam[1];
  }

  return account;
};

export const GENERATE_HASH = (requestName, params) => {
  var MD5 = require("md5.js");

  let account = getAccountParamOrLocal();

  let params_hash = {};

  params_hash["PARAMS"] = params;

  if (account) {
    params_hash["HEADER-Account"] = `${account}`;
  }

  var request_hash = new MD5()
    .update(requestName + JSON.stringify(params_hash))
    .digest("hex");
  return request_hash;
};

export const CHECK_CACHE = (hash) => {
  var now = Date.now();
  if (cache_request[hash]) {
    if (cache_request[hash].expire >= now) {
      return Promise.resolve(cache_request[hash].response.data);
    }
    // if exists but expire is not valid anymore, deletes cache
    delete cache_request[hash];
    return false;
  }
};

export const SAVE_CACHE = (hash, result) => {
  var now = Date.now();
  cache_request[hash] = {
    expire: now + 2700000, // now + 45 minutes
    response: result,
  };
};

// DEFINE MANAGER AXIOS REQUESTS
const MAX_CONCURRENT_REQUESTS = 20;

// init your manager.
export const managerPanel = ConcurrencyManager(
  HTTP_TOKEN,
  MAX_CONCURRENT_REQUESTS
);
export const managerReport = ConcurrencyManager(
  HTTP_TOKEN_REPORT,
  MAX_CONCURRENT_REQUESTS
);

// CUSTOM INTERCEPTORS
HTTP_TOKEN.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    let account = getAccountParamOrLocal();

    if (account) {
      config.headers["Account"] = `${account}`;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

HTTP_TOKEN_REPORT.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    let account = getAccountParamOrLocal();

    if (account) {
      config.headers["Account"] = `${account}`;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

HTTP_TOKEN_REPORT.interceptors.request.use(
  (config) => {
    let modulesNoCache = ["shortlink", "shortlinkwhats"];
    let url = config.url && config.url.toLowerCase();

    if (modulesNoCache.includes(url)) {
      config.headers["Cache-Control"] = "no-cache";
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

// Add a 401 response interceptor
HTTP_TOKEN.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    let urlRequest =  error && error.request && error.request.responseURL
    let flag = false
    
    if (urlRequest && urlRequest.includes('check-is-logged')) {
      flag = true
    }
    if (!flag && error.response && [401, 403].includes(error.response.status)) {
      localStorage.removeItem("token");
      localStorage.removeItem("account");
      window.location = "/";
    } else {
      return Promise.reject(error);
    }
  }
);

HTTP_TOKEN_REPORT.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response && [401, 403].includes(error.response.status)) {
      localStorage.removeItem("token");
      localStorage.removeItem("account");

      window.location = "/";
    } else {
      return Promise.reject(error);
    }
  }
);

// CANCEL REQUESTS IN CHANGE ROUTE
const CancelToken = axios.CancelToken;
export const SOURCE_CANCEL = CancelToken.source();

export const requestInterceptor = (config) => {
  let ignorePaths = ["user/accounts", "user", "account", "notification"];

  if (config && ignorePaths.includes(config.url)) {
    return config;
  }

  //  Generate cancel token source
  let source = axios.CancelToken.source();

  // Set cancel token on this request
  config.cancelToken = source.token;

  // Add to vuex to make cancellation available from anywhere
  store.commit("ADD_CANCEL_TOKEN", source);

  return config;
};

HTTP_TOKEN_REPORT.interceptors.request.use(requestInterceptor, function(error) {
  return Promise.reject(error);
});

HTTP_TOKEN.interceptors.request.use(requestInterceptor, function(error) {
  return Promise.reject(error);
});
